import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER, square } from '@/styles/common.styled';
import { FLEX_COLUMN_DIV } from '@/styles/common.styled.component';

export const ComponentWrapper = styled(FLEX_COLUMN_DIV)`
    justify-content: space-between;
    align-items: center;
    padding: 11px 16px;
    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
    background-color: ${GRAY(10)};

    .top-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            ${FLEX_CENTER}
            padding: 0;
            margin: 0;

            svg {
                ${square(16)}
                margin-right: 8px;
            }

            h1 {
                flex: 1;
                color: ${GRAY(100)};
                font-size: 14px;
                font-weight: 500;
                margin-right: 6px;
            }
        }
    }
`;
